import MediaSlider from "./media-slider";

export default MediaSlider;